export default __webpack_public_path__ + "static/media/Portrett-Ibrahim-tekstet-151220.56fd780b.mp4";